import {
    convertCardsToTree,
    extractConnectedCards,
} from '../../../utils/convert-cards-to-tree';
import { buildSurveyConfig } from '../../expensive-selectors/build-survey-config';
import type { StoreState } from '../../state-types';

/** Check if the card is connected to the other cards in the survey */
export const checkCardIsConnected =
    (cardId: string) =>
    (state: StoreState): boolean => {
        const surveyConfig = buildSurveyConfig(state);
        const startCard = surveyConfig.cards[0];
        const treeInfo = convertCardsToTree(startCard, surveyConfig.cards);
        const connectedCardIds = extractConnectedCards([], treeInfo);
        const isCoreQuestionView = connectedCardIds.length === 0;

        return isCoreQuestionView ? true : connectedCardIds.includes(cardId);
    };
